import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateroles',
  pure: true,
})
/**
 * Translates an array of roles into user visible strings
 */
export class TranslateRolesPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(roles: string | Array<string>, mode: string = 'singular') {
    if (!Array.isArray(roles)) {
      return this.transform([roles]);
    }
    if (mode === 'plural') {
      return roles.map((role) => this.translate.instant(`roles.plural.${role}`));
    } else {
      return roles.map((role) => this.translate.instant(`roles.${role}`));
    }
  }
}
